import {AppConfig, BaseAppProps, BaseAppState} from "shared/BaseApp";
import React, {ReactElement} from 'react';
import {PathComponent} from "../index";
import {FIREBASE_CONFIG} from "../consts";
import {ProvisionedApp} from "../shared/ProvisionedApp";
import {AppPrefListener, ProvisionedAppConfig} from "../shared/types";
import {LoginConfig} from "../shared/Login";
import {THEME} from "./theme";
import {Main} from "./Main";

export type AppProps = BaseAppProps & {}

type AppState = BaseAppState & {}

export class App extends ProvisionedApp<AppProps, AppState> implements AppPrefListener {

  protected getLoginConfig(): LoginConfig | null | undefined {
    return {
      noLogin: true,
    };
  }

  onCreateAppConfig(): AppConfig {
    return {
      name: "Smilebook",
      icon: "/logo192.png",
      logo: "/logo192.png",
      theme: THEME,
      privacyUrl: "",
      termsUrl: "",
      loginConfig: this.getLoginConfig(),
      firebaseConfig: {options: FIREBASE_CONFIG},
    };
  }

  getProvisionedAppId(): string {
    return "dentwyze";
  }

  getProvisionedAppConfig(): ProvisionedAppConfig | null {
    return undefined;
  }

  static nestedPaths(): PathComponent[] {
    return [];
  }

  protected renderMain(): ReactElement {
    return <Main/>;
  }
}
